/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_StoppedInputs */

const en_follow_stopped = /** @type {(inputs: Follow_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No longer following.`)
};

/**
* | output |
* | --- |
* | "No longer following." |
*
* @param {Follow_StoppedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const follow_stopped = /** @type {((inputs?: Follow_StoppedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_StoppedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_follow_stopped(inputs)
});